import { useMutation } from '@apollo/client';

import LearnerObjectUpdateLastIndicatedUnsureSkillsAt from 'bundles/onboarding-common/queries/LearnerObjectUpdateLastIndicatedUnsureSkillsAt.graphql';
import type {
  LearnerObject_UpdateLastIndicatedUnsureSkillsAtMutation as LearnerObjectUpdateLastIndicatedUnsureSkillsAtMutationType,
  LearnerObject_UpdateLastIndicatedUnsureSkillsAtMutationVariables as LearnerObjectUpdateLastIndicatedUnsureSkillsAtMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectUpdateLastIndicatedUnsureSkillsAt';

const useLearnerObjectUpdateLastIndicatedUnsureSkillsAt = () => {
  const [updateLastIndicatedUnsureSkillsAtMutation] = useMutation<
    LearnerObjectUpdateLastIndicatedUnsureSkillsAtMutationType,
    LearnerObjectUpdateLastIndicatedUnsureSkillsAtMutationVariables
  >(LearnerObjectUpdateLastIndicatedUnsureSkillsAt, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateLastIndicatedUnsureSkillsAt = async (timestamp: string) => {
    const variables: LearnerObjectUpdateLastIndicatedUnsureSkillsAtMutationVariables = {
      input: {
        lastIndicatedUnsureSkillsAt: timestamp,
      },
    };

    const { errors, data } = await updateLastIndicatedUnsureSkillsAtMutation({
      variables,
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (
      data?.LearnerObject_UpdateLastIndicatedUnsureSkillsAt.__typename ===
      'LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError'
    ) {
      return {
        success: false,
        errors: [data.LearnerObject_UpdateLastIndicatedUnsureSkillsAt.message],
      };
    }

    return { success: true, errors: [] };
  };

  return {
    updateLastIndicatedUnsureSkillsAt,
  };
};

export default useLearnerObjectUpdateLastIndicatedUnsureSkillsAt;
